<template>
    <div>
        <el-row>
            <el-col :span="24">
                <Head>
                    <template v-slot:title>
                        <span style="margin-left:30%;"></span>
                    </template>
                </Head>
            </el-col>
        </el-row>
        <el-row class="row-top" type="flex" justify="center">
            <el-col :span="15">
                <recruitList v-if="isShow" @statusFun="getStatus"></recruitList>
                <recruitXq v-else :status="status"></recruitXq>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import Head from '@/components/header/head.vue';
import recruitList from '@/views/recruit/recruit_list.vue';
import recruitXq from '@/views/recruit/recruit_xq.vue';
export default {
    data(){
        return {
            isShow:true,
            status:''
        }
    },
    methods:{
       getStatus(isShow,status){
        console.log(isShow,status)
           this.isShow = isShow
           this.status = status
       }
    },
    components:{
        Head,
        recruitList,
        recruitXq
        
    }
}
</script>
<style lang="less" scoped>
        
</style>